export default __webpack_public_path__ + "static/media/gallery-04_full.419e1b02.jpg";